import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Box } from 'localmed-core';

import style from './LeafletMap.scss';

import LeafletProvider, { LeafletTileLayer } from '../LeafletProvider';
import LeafletMarker from './LeafletMarker';

class LeafletMap extends Component {
  renderBody = (props) => {
    const { leaflet } = props;

    const {
      markers,
      activeMarker,
      markerSize,
      viewport,
      boundsOptions,
      hasZoomControl,
      onViewportChanged,
      onMarkerHover,
      v2,
      ...containerProps
    } = this.props;

    if (!leaflet || !markers || markers.length === 0)
      return <div className={style['leafleft-map']} />;

    const viewportOptions = {};
    if (viewport) {
      viewportOptions.viewport = viewport;
    } else {
      viewportOptions.bounds = markers.map((marker) => [
        parseFloat(marker.latitude),
        parseFloat(marker.longitude),
      ]);
      viewportOptions.boundsOptions = boundsOptions || {
        paddingTopLeft: [12, 36],
        paddingBottomRight: [12, 12],
        maxZoom: 15,
      };
    }

    const { Map, ZoomControl, DivIcon } = leaflet;

    return (
      <Box backgroundColor="grays.50" height={150} {...containerProps}>
        <Map
          className={style['leaflet-map']}
          onViewportChanged={onViewportChanged}
          attributionControl={false}
          zoomControl={false}
          scrollWheelZoom={false}
          animate
          {...viewportOptions}
        >
          <LeafletTileLayer leaflet={leaflet} />
          {hasZoomControl && <ZoomControl position="bottomright" />}
          {this.renderLeafletMarkers(markers, activeMarker, markerSize, DivIcon, onMarkerHover, v2)}
        </Map>
      </Box>
    );
  };

  renderLeafletMarkers = (markers, activeMarker, markerSize, DivIcon, onMarkerHover, v2) =>
    markers.map((marker, index) => {
      const isActive = activeMarker && activeMarker.id === marker.id;
      return (
        <DivIcon
          key={marker.id}
          className={style['marker-icon-container']}
          position={[marker.latitude, marker.longitude]}
          iconSize={[0, 0]}
          zIndexOffset={isActive ? 1000 : 0}
        >
          <LeafletMarker
            isActive={isActive}
            number={index}
            marker={marker}
            markerSize={markerSize}
            onMarkerHover={onMarkerHover}
            v2={v2}
          />
        </DivIcon>
      );
    });

  render = () => <LeafletProvider render={this.renderBody} />;
}

export default withRouter(LeafletMap);
